const GUIDE_SELECTOR = '[data-goodlot-condition-guide]';
const HEADER_SELECTOR = '#header-component';
const MOBILE_MENU_SELECTOR = '#Details-menu-drawer-container';

function clamp(value, min, max) {
  return Math.min(max, Math.max(min, value));
}

function initGoodLotConditionGuideHeaderSync(root) {
  if (!root || root.dataset.goodlotHeaderSyncInitialized === 'true') return;

  root.dataset.goodlotHeaderSyncInitialized = 'true';

  const jump = root.querySelector('.goodlot-condition-guide__jump');
  const header = document.querySelector(HEADER_SELECTOR);

  if (!jump || !header) return;

  const mobileMenu = header.querySelector(MOBILE_MENU_SELECTOR);

  let rafId = null;

  const sync = () => {
    rafId = null;

    const headerStyle = getComputedStyle(header);
    const headerHeight = Math.max(header.offsetHeight, 0);

    const rawOffset = Number.parseFloat(
      headerStyle.getPropertyValue('--goodlot-nav-offset')
    );

    const headerOffset = clamp(
      Number.isFinite(rawOffset) ? rawOffset : 0,
      0,
      headerHeight
    );

    /*
      GoodLot's header moves upward by --goodlot-nav-offset.
      The visible part of the header is therefore:
      headerHeight - headerOffset.
    */
    const visibleHeaderHeight = Math.max(0, headerHeight - headerOffset);
    const hideProgress = headerHeight > 0 ? headerOffset / headerHeight : 0;

    /*
      Keep the guide fully visible at the beginning of the header movement,
      then fade it away as the main header leaves the viewport.
      On upward scroll the same values reverse, so both return together.
    */
    const opacity = clamp((0.82 - hideProgress) / 0.42, 0, 1);
    const isHidden = hideProgress >= 0.96;

    jump.style.setProperty(
      '--glcg-header-visible-height',
      `${Math.round(visibleHeaderHeight)}px`
    );

    jump.style.setProperty('--glcg-jump-opacity', String(opacity));
    jump.style.setProperty(
      '--glcg-jump-visibility',
      isHidden ? 'hidden' : 'visible'
    );
    jump.style.setProperty(
      '--glcg-jump-pointer-events',
      opacity < 0.2 ? 'none' : 'auto'
    );

    /*
      Anchor links need to land below both visible sticky layers.
    */
    root.style.setProperty(
      '--glcg-anchor-offset',
      `${Math.round(visibleHeaderHeight + jump.offsetHeight + 16)}px`
    );

    const menuOpen = Boolean(mobileMenu?.open);
    root.classList.toggle('is-goodlot-menu-open', menuOpen);
  };

  const scheduleSync = () => {
    if (rafId !== null) return;
    rafId = requestAnimationFrame(sync);
  };

  /*
    Your GoodLot header already updates --goodlot-nav-offset on its style
    attribute while scrolling. Watching that value keeps this guide aligned
    with the exact same animation rather than creating a second scroll system.
  */
  const headerObserver = new MutationObserver(scheduleSync);
  headerObserver.observe(header, {
    attributes: true,
    attributeFilter: ['style', 'class', 'data-sticky-state'],
  });

  const resizeObserver = new ResizeObserver(scheduleSync);
  resizeObserver.observe(header);
  resizeObserver.observe(jump);

  mobileMenu?.addEventListener('toggle', scheduleSync);

  window.addEventListener('resize', scheduleSync, { passive: true });

  /*
    Fallback for any frame in which the header changes position without
    mutating an observed attribute.
  */
  const desktopScrollMedia = window.matchMedia('(min-width: 990px)');
  let scrollSource = null;

  const bindScrollSource = () => {
    if (scrollSource) {
      scrollSource.removeEventListener('scroll', scheduleSync);
    }

    scrollSource = desktopScrollMedia.matches
      ? document.querySelector('.page-wrapper') || window
      : window;

    scrollSource.addEventListener('scroll', scheduleSync, { passive: true });
    scheduleSync();
  };

  desktopScrollMedia.addEventListener('change', bindScrollSource);
  bindScrollSource();
}

function initAllGoodLotConditionGuides(scope = document) {
  scope.querySelectorAll(GUIDE_SELECTOR).forEach((root) => {
    initGoodLotConditionGuideHeaderSync(root);
  });
}

if (document.readyState === 'loading') {
  document.addEventListener(
    'DOMContentLoaded',
    () => initAllGoodLotConditionGuides(document),
    { once: true }
  );
} else {
  initAllGoodLotConditionGuides(document);
}

document.addEventListener('shopify:section:load', (event) => {
  initAllGoodLotConditionGuides(event.target);
});